var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{on:{"click":_vm.click}},[_c('img',{attrs:{"src":_vm.buttonImage,"alt":"Back"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }